import Form from 'components/Form';
import { IFormValues } from 'routes/Main/type';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import SectionTitle from '../components/SectionTitle';

import SubMuiRadio from './MuiRadioGroupSub';

interface Props extends IFormValues {
  disabled?: boolean;
}

const FunctionalEvaluation = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <RowContainer>
      <SectionTitle title="ADL(Өдөр тутмын амьдралын үйл ажиллагаа)" mb={0} />

      <RowContainer ratio={12}>
        <RowContent title="Өөрөө суух" titleRatio={3.5} childrenRatio={8}>
          <SubMuiRadio
            i18nKey="HOSPITALIZATION.FUNCTIONAL.EVALUATION"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('functional_evaluation.sit')}
            onChange={v => setValue('functional_evaluation.sit', v)}
          />
        </RowContent>
        <RowContent title="Өөрөө сууж босох" titleRatio={3.5} childrenRatio={8}>
          <SubMuiRadio
            i18nKey="HOSPITALIZATION.FUNCTIONAL.EVALUATION"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('functional_evaluation.stand_up')}
            onChange={v => setValue('functional_evaluation.stand_up', v)}
          />
        </RowContent>
        <RowContent
          title="Орноос тэргэнцэр рүү шилжих"
          titleRatio={3.5}
          childrenRatio={8}
        >
          <SubMuiRadio
            i18nKey="HOSPITALIZATION.FUNCTIONAL.EVALUATION"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('functional_evaluation.wheel_chair')}
            onChange={v => setValue('functional_evaluation.wheel_chair', v)}
          />
        </RowContent>
        <RowContent title="Бие даан алхах" titleRatio={3.5} childrenRatio={8}>
          <SubMuiRadio
            i18nKey="HOSPITALIZATION.FUNCTIONAL.EVALUATION"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('functional_evaluation.walk')}
            onChange={v => setValue('functional_evaluation.walk', v)}
          />
        </RowContent>
      </RowContainer>
    </RowContainer>
  );
};

export default FunctionalEvaluation;
